import { useRef } from "react";
import { motion } from "framer-motion";
import toog1 from "../images/toog1.jpg";
import toog2 from "../images/toog2.jpg";
import toog3 from "../images/toog3.jpg";
import toog4 from "../images/toog4.jpg";
import toog5 from "../images/toog5.jpg";
import toog6 from "../images/toog6.jpg";
import toog7 from "../images/toog7.jpg";
import toog8 from "../images/toog8.jpg";
import toog9 from "../images/toog9.jpg";

const images = [toog1, toog2, toog3, toog4, toog5, toog6, toog7, toog8, toog9];

export default function ButtonScrollGallery() {
  const scrollRef = useRef(null);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const disableScroll = (event) => {
    event.preventDefault();
  };

  return (
    <div 
      className="relative w-full overflow-hidden flex items-center"
      onWheel={disableScroll}
    >
      <button 
        aria-label="Scroll Left"
        className="absolute left-2 z-10 bg-white text-black p-4 rounded-full shadow-lg text-xl font-bold hover:bg-gray-800 hover:text-white transition duration-300"
        onClick={scrollLeft}
      >
        ◀
      </button>

      <div
        ref={scrollRef}
        className="flex space-x-4 overflow-x-auto scroll-smooth py-4"
        style={{ scrollBehavior: "smooth", whiteSpace: "nowrap" }}
      >
        {images.map((src, index) => (
          <motion.img
            key={index}
            src={src}
            alt="Gallery Image"
            className="w-72 sm:w-80 md:w-96 h-60 object-cover rounded-lg shadow-lg"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          />
        ))}
      </div>

      <button 
        aria-label="Scroll Right"
        className="absolute right-2 z-10 bg-white text-black p-4 rounded-full shadow-lg text-xl font-bold hover:bg-gray-800 hover:text-white transition duration-300"
        onClick={scrollRight}
      >
        ▶
      </button>
    </div>
  );
}